export const GET_ORDER = 'GET_ORDER';
export const GET_CUSTOMER = 'GET_CUSTOMER';
export const GET_PROVIDER = 'GET_PROVIDER';
export const ISSUE_REFUND = 'ISSUE_REFUND';